import { acceptOnlyValidOptionByValue } from '../../field-viewer/shared-normalizers';
export const mlaSubdivisionViewer = {
    normalizeLoadedValue: acceptOnlyValidOptionByValue
};

//# sourceMappingURL=definition-viewer.js.map